import { useContext, useState } from 'react';

import AdminModal from '../../reusable/admin-modal/admin-modal.component.jsx';
import Button from '../../reusable/button/button.component.jsx';
import ComponentModal from '../../reusable/component-modal/component-modal.component.jsx';
import AddFulfillment from '../../fulfillment/add-fulfillment/add-fulfillment.component.jsx';

import { ToastContext } from '../../../contexts/toast.context.jsx';

import Client from '../../../tools/client.js';

import {
    ContentContainer,
    Input,
    MainContainer,
    RowContainer
} from '../../../styles/component.styles';

const client = new Client();

const ProcessOrder = ({ user, order, getOrder }) => {
    const [ paymentLink, setPaymentLink ] = useState('');
    const [ title, setTitle ] = useState('');
    const [ message, setMessage ] = useState('');
    const [ action, setAction ] = useState('');
    const [ showOrderModal, setShowOrderModal ] = useState(false);
    const [ showCreateFulfillment, setShowCreateFulfillment ] = useState(false);

    const { errorToast } = useContext(ToastContext);

    const confirmSendPaymentLink = () => {
        if(paymentLink.length === 0) {
            errorToast('Please add a Payment Link to update order status to billed.');
            return
        }
        setTitle('Send Payment Link');
        setMessage(`Are you sure you want to send the payment link: ${paymentLink}?`);
        setAction(() => sendPaymentLink);
        setShowOrderModal(true);
    }

    const confirmMarkPaid = () => {
        setTitle('Mark Paid');
        setMessage('Are you sure you want to mark the order as PAID? Please ensure the customer has paid the correct invoice');
        setAction(() => invoicePaid);
        setShowOrderModal(true);
    }

    const sendPaymentLink = async () => {
        const data = {
            id: order.id,
            status: 'billed',
            paymentLink
        }

        await client.sendPaymentLink(data);
        setShowOrderModal(false);
        getOrder();
    }

    const invoicePaid = async () => {
        const data = {
            id: order.id,
            status: 'paid'
        };

        if (paymentLink) {
            data.paymentLink = paymentLink;
        }

        await client.updateOrder(data);
        setShowOrderModal(false);
        getOrder();
    }

    return (
        <MainContainer>
            <AdminModal 
                show={showOrderModal}
                setShow={setShowOrderModal}
                title={title} 
                image={''}
                message={message} 
                action={action} 
                actionText={'Process'}
            />
            <ComponentModal
                isOpen={showCreateFulfillment}
                onClose={() => setShowCreateFulfillment(false)}
                title="Category Thumbnail"
            >
                <AddFulfillment order={order} refreshOrder={getOrder} />
            </ComponentModal>
            <ContentContainer>
                {order.status.toLowerCase() === 'new' && (
                    <>
                        <RowContainer>
                            <ContentContainer margin={'20px 0'}>
                                <Input value={paymentLink} onChange={(e) => setPaymentLink(e.target.value)} placeholder='Payment Link' />
                            </ContentContainer>
                        </RowContainer>
                        <RowContainer>
                            <Button onClick={() => invoicePaid()} >Mark Paid</Button>
                            <Button onClick={() => confirmSendPaymentLink()} >Send Payment Link</Button>
                        </RowContainer>
                    </>
                )}

                {order.status.toLowerCase() === 'billed' && (
                    <RowContainer>
                        <Button onClick={() => confirmMarkPaid()} >Bill Paid</Button>
                    </RowContainer>
                )}

                {(order.status.toLowerCase() === 'paid' || order.status.toLowerCase() === 'processing' || order.status.toLowerCase() === 'partially_shipped') && (
                    <ContentContainer margin={'20px 0'}>
                        <Button onClick={() => setShowCreateFulfillment(true)}>Create Fulfillment</Button>
                    </ContentContainer>
                )}
            </ContentContainer>
        </MainContainer>
    )
}

export default ProcessOrder;